import { bindable } from 'aurelia-framework';

export class UserEntryButtons {
	@bindable userId: string;
	@bindable removeEnabled: boolean = false;
	removeForm: HTMLFormElement;

	removeUser() {
		this.removeForm.submit();
	}
}
